module.exports = __webpack_public_path__ + "static/media/band2.83453259.jpg";